/**
 * compare.js — نغمة ستور
 * ------------------------------------------------------------
 * مقارنة المنتجات: محفوظة محليًا فقط عبر localStorage على متصفح/جهاز
 * العميل الحالي (المفتاح naghmah:compare:v1) — لا مزامنة مع حساب Shopify،
 * لا مزامنة بين الأجهزة، لا Customer Account API، لا App. صيغة كل عنصر
 * مخزَّن: { id, handle, url, addedAt } فقط — لا سعر ولا مخزون ولا عنوان
 * ولا صورة مخزَّنة هنا إطلاقًا؛ بيانات العرض الفعلية (صورة/عنوان/سعر/
 * توفر/ماركة/نوع منتج/وصف/خيارات) تُجلب حديثًا من Shopify عبر Section
 * Rendering API عند عرض صفحة المقارنة (sections/compare-product-data.liquid)،
 * لا من localStorage. المقارنة على مستوى Product فقط، لا Variant محددة.
 *
 * الحد الأقصى أربعة منتجات (MAX_ITEMS): خلافًا للمفضلة (التي تُسقط أقدم
 * عنصر تلقائيًا بعد 100)، هنا لا يُحذف أي منتج قديم تلقائيًا عند محاولة
 * إضافة منتج خامس — التخزين لا يتغيّر إطلاقًا، وتظهر رسالة صريحة عبر
 * aria-live بأن الحد الأقصى أربعة (compare.limit_reached).
 *
 * هذا الملف مستقل تمامًا عن assets/wishlist.js (لا استيراد ولا اعتماد
 * متبادل، ولا تعديل على wishlist.js إطلاقًا) لكنه يستفيد معماريًا من
 * الدروس المستخلصة من نسخها الأربع (V1-V4): بنية Run + Global Scheduler
 * محصَّنة من البداية (بلا حاجة لتصحيحات لاحقة) — أسماء الحالة والمجدوِل
 * هنا مستقلة تمامًا (comparePageStates، compareFetchScheduler، data-compare-*)
 * لتفادي أي تعارض إن عُرض قسما Wishlist وCompare معًا في نفس الصفحة.
 *
 * مستمع نقر واحد مفوَّض (delegated) على مستوى document لكل من: تبديل
 * المقارنة [data-compare-toggle]، مسح الجميع [data-compare-clear-all]،
 * إعادة محاولة تحميل عمود [data-compare-retry]، وإزالة عمود غير متاح
 * [data-compare-remove-unavailable] بالإضافة لزر إزالة العمود العادي
 * [data-compare-remove-column] — بنفس نمط wishlist.js/product-card.js
 * المعتمد في بقية الثيم.
 *
 * Compare V2 (مراجعة صاحبة المشروع للنسخة الأولى): جدول المقارنة أصبح
 * دلاليًا بالكامل — كل منتج رأس عمود حقيقي (thead th scope="col")، وكل
 * خاصية (السعر/التوفر/...) رأس صف حقيقي (tbody th scope="row")؛ لم يعد
 * هناك "صف product" داخل tbody إطلاقًا. مزامنة الأزرار المحقونة ديناميكيًا
 * (Product Recommendations وWishlist Cards عبر innerHTML، وCombined
 * Listing عبر استبدال كامل للصفحة) أصبحت آلية عبر MutationObserver عالمية
 * واحدة على document.body بالإضافة لمستمع naghmah:product-changed — بلا
 * أي تعديل على wishlist.js أو product-recommendations.js أو product.js.
 * findMatchingItem (أولوية id ثم handle) تُستخدم الآن عبر كامل تدفق
 * القراءة/الإضافة/الحذف/المزامنة لتفادي معاملة نفس المنتج كمنتج مختلف
 * حين تتغيّر id المخزَّنة بينما handle يبقى ثابتًا.
 *
 * Compare V3 (إصلاح صغير ونهائي بعد مراجعة فعلية للـZIP): loadOneColumn
 * تتجاهل الآن بصمت أي نتيجة شبكة متأخرة (نجاح، 404، أو خطأ) لعمود أُزيل
 * فعليًا من الجدول أثناء بقاء طلبه جاريًا — عبر فحص وجود رأس العمود حيًا
 * (findProductHeader) قبل أي render أو announce. syncComparePageAfterChangeForRoot
 * تستخدم الآن Set بدل كائن عادي لمجموعة IDs الباقية (اتساقًا مع sanitizeItems).
 */
(function () {
  "use strict";

  var STORAGE_KEY = "naghmah:compare:v1";
  var MAX_ITEMS = 4;
  var CONCURRENCY_LIMIT = 4;
  var SECTION_ID = "compare-product-data";

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;
  Naghmah.strings = Naghmah.strings || {};

  var delegatedListenersBound = false;

  /* ======================================================================
     دالة مساعدة عامة: تضمن تنفيذ fn مرة واحدة بالضبط مهما استُدعيت الدالة
     الناتجة عدة مرات — نفس نمط once() المعتمد في wishlist.js V3/V4، هنا
     محصَّنة من البداية بلا حاجة لتصحيح لاحق.
     ====================================================================== */
  function once(fn) {
    var called = false;
    return function () {
      if (called) return;
      called = true;
      return fn.apply(this, arguments);
    };
  }

  /* ======================================================================
     Global Scheduler: طابور واحد لكل طلبات Section Rendering الخاصة
     بالمقارنة عبر كل أقسام main-compare معًا — الحد الحقيقي عبر الصفحة
     كلها هو CONCURRENCY_LIMIT (4)، لا 4 لكل قسم على حدة (نفس درس V3 من
     wishlist.js). schedulerPump محمي بـtry/catch حول استدعاء taskFn منذ
     البداية (درس V4 من wishlist.js: استثناء متزامن من مهمة لا يجوز أن
     يُبقي فتحة الحد العالمي مشغولة للأبد).
     ====================================================================== */
  var compareFetchScheduler = {
    active: 0,
    pending: [] /* كل عنصر: { run, taskFn } */
  };

  function schedulerPump() {
    while (
      compareFetchScheduler.active < CONCURRENCY_LIMIT &&
      compareFetchScheduler.pending.length > 0
    ) {
      var entry = compareFetchScheduler.pending.shift();
      entry.run.pendingTasks.delete(entry);

      if (entry.run.cancelled) continue;

      compareFetchScheduler.active++;
      (function (entry) {
        var done = once(function () {
          compareFetchScheduler.active--;
          schedulerPump();
        });
        try {
          entry.taskFn(done);
        } catch (error) {
          done();
        }
      })(entry);
    }
  }

  function schedulerEnqueue(run, taskFn) {
    var entry = { run: run, taskFn: taskFn };
    run.pendingTasks.add(entry);
    compareFetchScheduler.pending.push(entry);
    schedulerPump();
  }

  /* ======================================================================
     حالة مستقلة لكل قسم Compare عبر WeakMap: كل جذر
     [data-section-type="main-compare"] يملك { sequence, currentRun } —
     لا تعارض بين قسمين معروضين معًا. نموذج "Run" مطابق تمامًا لدرس V3 من
     wishlist.js: كل جولة تهيئة تُنشئ Run جديدة وتُلغي القديمة بأمان بلا
     تصفير عدّاد مشترك عبر الأجيال.
     ====================================================================== */
  var comparePageStates = new WeakMap();

  function getPageState(root) {
    var state = comparePageStates.get(root);
    if (!state) {
      state = { sequence: 0, currentRun: null };
      comparePageStates.set(root, state);
    }
    return state;
  }

  function cancelRun(run) {
    if (!run || run.cancelled) return;
    run.cancelled = true;

    run.controllers.forEach(function (controller) {
      try {
        controller.abort();
      } catch (err) {
        /* لا شيء يستحق المعالجة. */
      }
    });
    run.controllers.clear();

    if (run.pendingTasks.size > 0) {
      compareFetchScheduler.pending = compareFetchScheduler.pending.filter(
        function (entry) {
          return entry.run !== run;
        }
      );
      run.pendingTasks.clear();
    }
  }

  function startNewRun(state) {
    if (state.currentRun) {
      cancelRun(state.currentRun);
    }
    state.sequence += 1;
    var run = {
      id: state.sequence,
      cancelled: false,
      controllers: new Set(),
      pendingTasks: new Set()
    };
    state.currentRun = run;
    return run;
  }

  /* ======================================================================
     طبقة التخزين (localStorage) — كل تعامل داخل try/catch، لا استثناء
     يُسمح له بكسر الصفحة.
     ====================================================================== */
  function getStorage() {
    try {
      return window.localStorage || null;
    } catch (err) {
      return null;
    }
  }

  function isSafeHandle(handle) {
    return typeof handle === "string" && /^[a-z0-9-]+$/.test(handle);
  }

  function isSameOriginProductPath(url) {
    if (typeof url !== "string" || url === "") return false;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      if (parsed.pathname.indexOf("/products/") === -1) return false;
      return true;
    } catch (err) {
      return false;
    }
  }

  function isValidStoredItem(item) {
    return (
      item &&
      typeof item === "object" &&
      item.id !== undefined &&
      item.id !== null &&
      String(item.id) !== "" &&
      isSafeHandle(item.handle) &&
      isSameOriginProductPath(item.url)
    );
  }

  /* تحقق صارم منذ البداية (درس V4 من wishlist.js): القيمة يجب أن تكون
     بالفعل من نوع "number" حقيقي، محدودة (لا NaN ولا Infinity)، وغير
     سالبة — وإلا تُعامَل كـ0. نص رقمي مثل "999"، null، NaN، Infinity،
     وأي رقم سالب تصبح جميعها 0؛ الرقم الحقيقي الموجب فقط يبقى كما هو. */
  function normalizeAddedAt(value) {
    if (
      typeof value !== "number" ||
      !Number.isFinite(value) ||
      value < 0
    ) {
      return 0;
    }
    return value;
  }

  function normalizeStoredItem(item) {
    return {
      id: String(item.id),
      handle: String(item.handle),
      url: String(item.url),
      addedAt: normalizeAddedAt(item.addedAt)
    };
  }

  function safeParseArray(raw) {
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed;
    } catch (err) {
      return [];
    }
  }

  /* sanitizeItems صريحة وموحَّدة (درس V4 من wishlist.js مُطبَّق منذ
     البداية هنا): تصفية البيانات الصالحة → تطبيع كل عنصر → ترتيب حسب
     addedAt تنازليًا أولًا → إزالة التكرار حسب id ثم handle كاحتياط →
     قص لحد أقصى MAX_ITEMS. الفرز قبل إزالة التكرار يضمن أن النسخة الأحدث
     تفوز دومًا عند تعارض id/handle، بصرف النظر عن ترتيبها الأصلي في
     مصفوفة التخزين. Set (لا كائنات عادية {}) تُستخدَم لتتبّع id/handle
     المُشاهَدة، لتفادي أي تأثير لمفاتيح مثل "__proto__"/"constructor" في
     بيانات localStorage غير الموثوقة.

     ملاحظة مهمة: قص الحد هنا هو شبكة أمان لإصلاح بيانات تالفة/يدوية تتجاوز
     4 عناصر فعليًا (مثال: تعديل يدوي لـlocalStorage) — وليس هو الآلية التي
     تمنع إضافة منتج خامس في التدفق العادي؛ تلك القاعدة (لا حذف تلقائي،
     رسالة صريحة) مطبَّقة صراحة داخل addItem أدناه قبل أي استدعاء لهذه
     الدالة، فلا تتعارض الآليتان. */
  function sanitizeItems(rawArray) {
    if (!Array.isArray(rawArray)) return [];

    var normalized = rawArray.filter(isValidStoredItem).map(normalizeStoredItem);

    normalized.sort(function (a, b) {
      return b.addedAt - a.addedAt;
    });

    var seenIds = new Set();
    var seenHandles = new Set();
    var deduped = [];
    normalized.forEach(function (item) {
      if (seenIds.has(item.id)) return;
      if (seenHandles.has(item.handle)) return;
      seenIds.add(item.id);
      seenHandles.add(item.handle);
      deduped.push(item);
    });

    return deduped.slice(0, MAX_ITEMS);
  }

  function readItems() {
    var storage = getStorage();
    if (!storage) return [];
    var raw;
    try {
      raw = storage.getItem(STORAGE_KEY);
    } catch (err) {
      return [];
    }
    if (!raw) return [];

    var clean = sanitizeItems(safeParseArray(raw));

    /* إصلاح Best Effort صامت (نفس نمط wishlist.js): لا Recursion، لا
       إعلان نجاح زائف، فشل الإصلاح لا يُعطِّل الصفحة. */
    try {
      var serialized = JSON.stringify(clean);
      if (raw !== serialized) {
        storage.setItem(STORAGE_KEY, serialized);
      }
    } catch (err) {
      /* فشل الإصلاح — لا مشكلة، clean تُعاد كما هي أدناه بصرف النظر. */
    }

    return clean;
  }

  function writeItems(items) {
    var storage = getStorage();
    if (!storage) return false;
    try {
      storage.setItem(STORAGE_KEY, JSON.stringify(items));
      return true;
    } catch (err) {
      return false;
    }
  }

  /* ======================================================================
     Compare V2 (بند 6): findMatchingItem — احتياط Handle عبر كامل التدفق.
     الأولوية دائمًا لتطابق id أولًا، ثم تطابق handle كاحتياط. هذا يسمح
     باكتشاف "نفس المنتج" حتى حين تختلف قيمة id المخزَّنة عن id الحالي
     القادم من الزر/الصفحة (مثال: بيانات منتج تغيّرت) طالما أن handle نفسه
     ما زال مطابقًا — بدل معاملته كمنتج مختلف تمامًا (وبالتالي كإضافة خامسة
     مرفوضة خطأً، أو كزر "غير مضاف" خطأً رغم وجود المنتج فعليًا في القائمة). */
  function findMatchingItem(items, id, handle) {
    if (!Array.isArray(items) || items.length === 0) return null;

    var idStr = id !== undefined && id !== null ? String(id) : "";
    if (idStr) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].id === idStr) return items[i];
      }
    }

    if (isSafeHandle(handle)) {
      for (var j = 0; j < items.length; j++) {
        if (items[j].handle === handle) return items[j];
      }
    }

    return null;
  }

  function hasItem(id, handle) {
    if ((id === undefined || id === null) && !isSafeHandle(handle)) return false;
    return findMatchingItem(readItems(), id, handle) !== null;
  }

  /* addItem تُعيد كائن نتيجة صريح (لا Boolean فقط) لأن هناك نتائج متعددة
     يجب التمييز بينها في واجهة المستخدم: نجاح، فشل تخزين حقيقي، أو رفض
     الإضافة لبلوغ الحد الأقصى (بلا أي فشل تخزين فعلي).

     Compare V2 (بند 6): قبل فحص MAX_ITEMS، يُفحص أولاً وجود عنصر مطابق
     بـid أو handle (findMatchingItem). إن وُجد تطابق بـhandle بينما id
     الجديدة مختلفة عن id المخزَّنة، تُحدَّث Metadata المخزَّنة في مكانها
     (id/url الجديدان، مع الحفاظ على addedAt الأصلي — لا تُعامَل كإضافة
     جديدة، ولا تُحسب ضمن حد الأربعة كمنتج خامس، ولا يُنشأ عنصر مكرر لنفس
     handle). */
  function addItem(meta) {
    if (!meta) return { ok: false, reason: "invalid" };
    var id = meta.id !== undefined && meta.id !== null ? String(meta.id) : "";
    var handle = typeof meta.handle === "string" ? meta.handle : "";
    var url = typeof meta.url === "string" ? meta.url : "";

    if (!id) return { ok: false, reason: "invalid" };
    if (!isSafeHandle(handle)) return { ok: false, reason: "invalid" };
    if (!isSameOriginProductPath(url)) return { ok: false, reason: "invalid" };

    var items = readItems(); /* نظيفة دائمًا بفضل sanitizeItems */

    var existingMatch = findMatchingItem(items, id, handle);
    if (existingMatch) {
      if (existingMatch.id === id) {
        /* موجود فعلًا بنفس id — لا حاجة لإضافة جديدة، يُعامَل كنجاح بلا
           تغيير. */
        return { ok: true };
      }

      /* تطابق عبر handle فقط، بينما id تغيّرت فعليًا — تحديث Metadata في
         مكانها بدل رفض الإضافة كمنتج خامس أو إنشاء نسخة مكررة لنفس
         handle. addedAt الأصلي يبقى كما هو (لا تُعامَل كمنتج "جديد" من
         ناحية ترتيب الإضافة). */
      var updatedItem = {
        id: id,
        handle: handle,
        url: url,
        addedAt: existingMatch.addedAt
      };
      var updatedItems = items.map(function (it) {
        return it.handle === existingMatch.handle ? updatedItem : it;
      });
      var mergedUpdate = sanitizeItems(updatedItems);
      var successUpdate = writeItems(mergedUpdate);
      return successUpdate ? { ok: true } : { ok: false, reason: "storage_error" };
    }

    /* القاعدة الصريحة: لا حذف تلقائي لأي منتج قديم عند بلوغ الحد الأقصى.
       التحقق هنا (بعد التأكد فعلًا من عدم وجود تطابق id/handle سابق) قبل
       أي كتابة فعلية — التخزين لا يتغيّر إطلاقًا حين تُرفض الإضافة لهذا
       السبب تحديدًا. */
    if (items.length >= MAX_ITEMS) {
      return { ok: false, reason: "limit_reached" };
    }

    var newItem = { id: id, handle: handle, url: url, addedAt: Date.now() };
    var merged = sanitizeItems([newItem].concat(items));
    var success = writeItems(merged);
    return success ? { ok: true } : { ok: false, reason: "storage_error" };
  }

  /* Compare V2 (بند 6): removeItem تقبل الآن handle احتياطيًا أيضًا —
     تبحث عن العنصر الحقيقي المطابق (id أولًا ثم handle) وتحذفه بمعرّفه
     المخزَّن الفعلي، لا بالضرورة بمعرّف الزر الذي استُدعيت منه (قد يختلفان
     في نفس سيناريو "نفس Handle بمعرّف جديد"). writeItems تُنفَّذ دائمًا —
     حتى حين لم يوجد العنصر أصلًا — لأن هذا التحقق الحقيقي الوحيد من أن
     localStorage قابلة للكتابة فعليًا الآن (نفس درس V3 من wishlist.js). */
  function removeItem(id, handle) {
    if (id === undefined || id === null) return false;
    var idStr = String(id);
    var items = readItems();
    var match = findMatchingItem(items, idStr, handle);
    var targetId = match ? match.id : idStr;
    var next = items.filter(function (it) {
      return it.id !== targetId;
    });
    return writeItems(next);
  }

  function clearAllItems() {
    return writeItems([]);
  }

  /* ======================================================================
     Live Region واحدة للإعلانات الصوتية — إنشاء برمجي فقط عبر
     createElement/textContent، لا HTML خام، لا innerHTML.
     ====================================================================== */
  function getOrCreateAnnouncer() {
    var el = document.querySelector("[data-compare-announcer]");
    if (el) return el;
    el = document.createElement("div");
    el.className = "visually-hidden";
    el.setAttribute("data-compare-announcer", "");
    el.setAttribute("aria-live", "polite");
    el.setAttribute("aria-atomic", "true");
    if (document.body) {
      document.body.appendChild(el);
    }
    return el;
  }

  function announce(text) {
    if (!text) return;
    var el = getOrCreateAnnouncer();
    if (!el) return;
    el.textContent = "";
    window.setTimeout(function () {
      el.textContent = text;
    }, 30);
  }

  /* ======================================================================
     مزامنة كل أزرار [data-compare-toggle] وعدّادات [data-compare-count].
     ====================================================================== */
  function applyButtonState(button, isActive) {
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    button.classList.toggle("is-compared", isActive);

    var addLabel = button.getAttribute("data-label-add") || "";
    var removeLabel = button.getAttribute("data-label-remove") || "";
    var label = isActive ? removeLabel : addLabel;

    if (label) {
      button.setAttribute("aria-label", label);
      var textEl = button.querySelector("[data-compare-toggle-label]");
      if (textEl) textEl.textContent = label;
    }
  }

  /* Compare V2 (بند 6): تعتمد على findMatchingItem (id ثم handle كاحتياط)
     بدل مقارنة id فقط — زر مُحمَّل ديناميكيًا يحمل id حالي مختلف عن id
     المخزَّن (بينما handle نفسه مطابق) يُعامَل الآن كمنتج "مضاف" فعليًا،
     لا كزر غير مضاف خطأً. عدد عناصر المقارنة صغير جدًا (أربعة كحد أقصى)
     فتكلفة findMatchingItem لكل زر مهملة حتى مع عدد كبير من الأزرار. */
  function syncToggleButtonsWithin(container, items) {
    if (!container) return;
    items = items || readItems();

    var buttons = container.querySelectorAll("[data-compare-toggle]");
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var pid = button.getAttribute("data-product-id");
      var phandle = button.getAttribute("data-product-handle");
      applyButtonState(button, findMatchingItem(items, pid, phandle) !== null);
    }
  }

  function syncAllToggleButtons(items) {
    syncToggleButtonsWithin(document, items);
  }

  /* ======================================================================
     Compare V2 (بند 1): مزامنة الأزرار المحقونة ديناميكيًا بعد التحميل
     الأولي — بطاقات Product Recommendations وWishlist (تُحقَن عبر innerHTML
     من ملفات لا يجوز تعديلها: product-recommendations.js وwishlist.js)،
     وProduct Page الجديدة الكاملة عند Combined Listing (تُستبدَل عبر
     product.js). لا تعديل على أي من تلك الملفات الثلاثة إطلاقًا — المزامنة
     هنا مبنية بالكامل داخل compare.js فقط، عبر آليتين مستقلتين:

     (أ) MutationObserver عالمية واحدة فقط على document.body (childList +
         subtree، بلا attributes — هذا يمنع بنيويًا أي Loop ناتج عن تحديث
         aria-pressed/النص الذي تُجريه applyButtonState نفسها، لأن هذه
         التحديثات تغيّر Attributes لا تضيف/تزيل عُقَدًا). لكل Batch من
         الـMutations تُقرأ localStorage مرة واحدة فقط (كسول: فقط إن وُجدت
         فعليًا عقدة مضافة تحمل زر مقارنة أو تحويه)، لا مرة لكل زر أو لكل
         Mutation فردية.
     (ب) مستمع مباشر على naghmah:product-changed (يُطلقه product.js فعليًا
         بعد كل استبدال Combined Listing ناجح، مع event.detail.pageRoot =
         الجذر الجديد المُستورَد) — مزامنة فورية للجذر الجديد تحديدًا، لا
         انتظار دورة الـMutationObserver التالية.
     ====================================================================== */
  var compareMutationObserver = null;

  function syncCompareButtonsForAddedNode(node, items) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches && node.matches("[data-compare-toggle]")) {
      var pid = node.getAttribute("data-product-id");
      var phandle = node.getAttribute("data-product-handle");
      applyButtonState(node, findMatchingItem(items, pid, phandle) !== null);
    }

    if (node.querySelectorAll && node.querySelectorAll("[data-compare-toggle]").length > 0) {
      syncToggleButtonsWithin(node, items);
    }
  }

  function initCompareMutationObserver() {
    if (compareMutationObserver) return; /* لا Observer مكررة إطلاقًا */
    if (typeof MutationObserver !== "function") return;
    if (!document.body) return;

    compareMutationObserver = new MutationObserver(function (mutationsList) {
      var items = null; /* قراءة واحدة كسولة لكل Batch — لا تُقرأ إلا عند
                            الحاجة الفعلية، ومرة واحدة فقط مهما كان عدد
                            العُقد/الأزرار المكتشفة ضمن نفس الـBatch. */
      for (var m = 0; m < mutationsList.length; m++) {
        var addedNodes = mutationsList[m].addedNodes;
        if (!addedNodes || addedNodes.length === 0) continue;

        for (var n = 0; n < addedNodes.length; n++) {
          var node = addedNodes[n];
          if (!node || node.nodeType !== 1) continue;

          var isToggle = node.matches && node.matches("[data-compare-toggle]");
          var hasToggleDescendant =
            node.querySelectorAll &&
            node.querySelectorAll("[data-compare-toggle]").length > 0;

          if (!isToggle && !hasToggleDescendant) continue;

          if (items === null) items = readItems();
          syncCompareButtonsForAddedNode(node, items);
        }
      }
    });

    compareMutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function updateCountBadges(count) {
    var badges = document.querySelectorAll("[data-compare-count]");
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(count);
      if (count > 0) {
        badges[i].removeAttribute("hidden");
      } else {
        badges[i].setAttribute("hidden", "hidden");
      }
    }
  }

  function isInsideHiddenParent(el) {
    if (!el) return true;
    return Boolean(el.closest && el.closest("[hidden]"));
  }

  function focusElementForA11y(el) {
    if (!el) return;
    if (isInsideHiddenParent(el)) return;
    if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
    el.focus();
  }

  /* ======================================================================
     بناء صفوف الجدول: تُحدَّد الصفوف الفعلية بناءً على إعدادات القسم
     (data-compare-show-vendor/-show-product-type/-show-description/
     -show-options الموجودة على غلاف .compare-page نفسه)، لأن Section
     Rendering API (المستخدَمة لجلب بيانات كل منتج) لا تصل إطلاقًا لإعدادات
     قسم main-compare من داخل compare-product-data.liquid المستقل تمامًا
     — نفس القيد المُوثَّق أصلاً في sections/wishlist-product-card.liquid.
     البيانات نفسها تُجلب دائمًا كاملة، وهذه الدالة فقط تقرر أي الصفوف
     تُبنى في الجدول أصلًا.
     ====================================================================== */
  /* Compare V2 (بند 2): "product" لم تعد صفًا داخل tbody إطلاقًا — أصبحت
     رأس عمود حقيقي (thead th scope="col") لكل منتج. getConfiguredRows
     الآن تُعيد فقط صفوف الخصائص الفعلية داخل tbody (لكل منها th
     scope="row" في عمود عناوين الصفوف). */
  function getConfiguredRows(root) {
    var rows = [
      { key: "price", label: Naghmah.strings.compareRowPrice || "" },
      { key: "availability", label: Naghmah.strings.compareRowAvailability || "" }
    ];

    if (root.getAttribute("data-compare-show-vendor") === "true") {
      rows.push({ key: "vendor", label: Naghmah.strings.compareRowVendor || "" });
    }
    if (root.getAttribute("data-compare-show-product-type") === "true") {
      rows.push({ key: "product_type", label: Naghmah.strings.compareRowProductType || "" });
    }
    if (root.getAttribute("data-compare-show-description") === "true") {
      rows.push({ key: "description", label: Naghmah.strings.compareRowDescription || "" });
    }
    if (root.getAttribute("data-compare-show-options") === "true") {
      rows.push({ key: "options", label: Naghmah.strings.compareRowOptions || "" });
    }

    return rows;
  }

  /* Compare V2 (بند 3): buildEmptyCell أصبحت مُستخدَمة فعليًا — تبني خلية
     tbody ابتدائية تحمل "—" محايدة (بدل خلية فارغة بصريًا بلا أي محتوى)
     حتى قبل وصول أي استجابة شبكة، ثم يستبدلها applyColumnData بالقيمة
     الحقيقية عند النجاح. */
  function buildEmptyCell(productId) {
    var cell = document.createElement("td");
    cell.className = "compare-table__cell";
    cell.setAttribute("data-product-id", productId);
    cell.textContent = "—";
    return cell;
  }

  /* Compare V2 (بند 3): تملأ كل خلايا tbody الخاصة بمنتج معيَّن بـ"—"
     محايدة — تُستدعى صراحة عند 404، غياب data-compare-product-data في
     الاستجابة، خطأ شبكة، أو استثناء أثناء التحليل/التطبيق. لا تترك أي صف
     (السعر/التوفر/بقية الصفوف) فارغًا بصريًا في أي من هذه الحالات. */
  function setColumnFallbackValues(table, productId) {
    var cells = table.querySelectorAll(
      'tbody td[data-product-id="' + cssEscapeValue(productId) + '"]'
    );
    for (var i = 0; i < cells.length; i++) {
      cells[i].textContent = "—";
    }
  }

  /* Compare V2 (بند 2): رأس عمود المنتج الحقيقي — th scope="col" داخل
     thead، لا td داخل tbody. يحمل data-compare-product-header
     وdata-product-id (وdata-product-handle احتياطيًا) لتحديده لاحقًا عبر
     كل دوال renderColumn(Unavailable/NetworkError)، applyColumnData،
     وretryColumn. */
  function buildLoadingProductHeader(item) {
    var th = document.createElement("th");
    th.setAttribute("scope", "col");
    th.className = "compare-table__cell compare-table__cell--product";
    th.setAttribute("data-compare-product-header", "");
    th.setAttribute("data-product-id", item.id);
    th.setAttribute("data-product-handle", item.handle);
    th.setAttribute("aria-busy", "true");

    var removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "button button--ghost compare-table__remove";
    removeButton.setAttribute("data-compare-remove-column", "");
    removeButton.setAttribute("data-product-id", item.id);
    removeButton.setAttribute("aria-label", Naghmah.strings.compareRemove || "");
    removeButton.textContent = Naghmah.strings.compareRemove || "";
    th.appendChild(removeButton);

    var loadingText = document.createElement("p");
    loadingText.className = "compare-table__loading";
    loadingText.textContent = Naghmah.strings.compareLoading || "";
    th.appendChild(loadingText);

    return th;
  }

  function findProductHeader(table, productId) {
    return table.querySelector(
      'thead th[data-compare-product-header][data-product-id="' +
        cssEscapeValue(productId) +
        '"]'
    );
  }

  /* Compare V2 (بند 2): إعادة بناء دلالية كاملة — كل منتج عمود حقيقي
     (thead th scope="col")، وكل خاصية صف حقيقي (tbody th scope="row").
     لا يوجد إطلاقًا صف "product" داخل tbody بعد الآن. صورة المنتج وعنوانه
     وزر الإزالة كلها داخل رأس العمود (th) نفسه، لا في خلية بيانات عادية. */
  function buildTable(root, items) {
    var rows = getConfiguredRows(root);

    var table = document.createElement("table");
    table.className = "compare-table";
    var scrollNoticeId = root
      .querySelector("[data-compare-table-container]")
      .getAttribute("data-scroll-notice-id");
    if (scrollNoticeId) {
      table.setAttribute("aria-describedby", scrollNoticeId);
    }

    var thead = document.createElement("thead");
    var headerRow = document.createElement("tr");

    var cornerHeader = document.createElement("th");
    cornerHeader.setAttribute("scope", "col");
    cornerHeader.className = "compare-table__row-label";
    cornerHeader.textContent = Naghmah.strings.compareRowProduct || "";
    headerRow.appendChild(cornerHeader);

    items.forEach(function (item) {
      headerRow.appendChild(buildLoadingProductHeader(item));
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    var tbody = document.createElement("tbody");

    rows.forEach(function (rowDef) {
      var tr = document.createElement("tr");
      tr.className = "compare-table__row";
      tr.setAttribute("data-compare-row", rowDef.key);

      var th = document.createElement("th");
      th.setAttribute("scope", "row");
      th.className = "compare-table__row-label";
      th.textContent = rowDef.label;
      tr.appendChild(th);

      items.forEach(function (item) {
        tr.appendChild(buildEmptyCell(item.id));
      });

      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    return table;
  }

  /* Compare V2 (بند 2 + 3): تستهدف الآن رأس العمود (thead th) بدل خلية
     tbody قديمة، وتملأ أيضًا بقية خلايا tbody الخاصة بهذا المنتج بـ"—"
     عبر setColumnFallbackValues — لا صف يبقى فارغًا بصريًا. */
  function renderColumnUnavailable(table, item) {
    var header = findProductHeader(table, item.id);
    if (!header) return;
    header.innerHTML = "";
    header.removeAttribute("aria-busy");

    var message = document.createElement("p");
    message.className = "compare-table__message";
    message.textContent = Naghmah.strings.compareUnavailable || "";
    header.appendChild(message);

    var removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "button button--ghost compare-table__remove";
    removeButton.setAttribute("data-compare-remove-unavailable", "");
    removeButton.setAttribute("data-product-id", item.id);
    removeButton.textContent = Naghmah.strings.compareRemove || "";
    header.appendChild(removeButton);

    setColumnFallbackValues(table, item.id);
  }

  function renderColumnNetworkError(table, item) {
    var header = findProductHeader(table, item.id);
    if (!header) return;
    header.innerHTML = "";
    header.removeAttribute("aria-busy");

    var message = document.createElement("p");
    message.className = "compare-table__message";
    message.textContent = Naghmah.strings.compareLoadError || "";
    header.appendChild(message);

    var retryButton = document.createElement("button");
    retryButton.type = "button";
    retryButton.className = "button button--secondary compare-table__retry";
    retryButton.setAttribute("data-compare-retry", "");
    retryButton.setAttribute("data-product-id", item.id);
    retryButton.setAttribute("data-product-handle", item.handle);
    retryButton.setAttribute("data-product-url", item.url);
    retryButton.textContent = Naghmah.strings.compareRetry || "";
    header.appendChild(retryButton);

    var removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "button button--ghost compare-table__remove";
    removeButton.setAttribute("data-compare-remove-unavailable", "");
    removeButton.setAttribute("data-product-id", item.id);
    removeButton.textContent = Naghmah.strings.compareRemove || "";
    header.appendChild(removeButton);

    setColumnFallbackValues(table, item.id);
  }

  function cssEscapeValue(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  /* لا نحقن استجابة الشبكة كاملة دون تحقق — نبحث تحديدًا عن الغلاف
     المتوقع (data-compare-product-data) داخل المستند المُحلَّل عبر
     DOMParser، ونستخرج فقط عناصر <template data-compare-field> المتوقعة
     عبر template.content.cloneNode(true) — لا حقن HTML خام.

     Compare V2 (بند 6): البحث عن الغلاف يتم أولاً عبر data-product-id
     (المعرّف الحالي)، وإن لم يُعثر عليه (مثال: id المخزَّن محليًا أصبح
     قديمًا لسبب ما) يُعاد المحاولة عبر data-product-handle كاحتياط قبل
     اعتبار المنتج "غير متاح" — فلا يُعامَل المنتج كغير موجود لمجرد أن id
     المحلي قديم بينما handle ما زال صحيحًا ومطابقًا فعليًا للاستجابة.

     Compare V2 (بند 4): تُعيد boolean صريح (لا تستدعي renderColumnUnavailable
     بنفسها) — هذا يسمح للمستدعي (loadOneColumn) بمركزية قرار الإعلان
     الصوتي وتفادي إعلان مكرر لنفس العمود. */
  function applyColumnData(table, item, html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var wrapper = doc.querySelector(
      '[data-compare-product-data][data-product-id="' + cssEscapeValue(item.id) + '"]'
    );
    if (!wrapper && isSafeHandle(item.handle)) {
      wrapper = doc.querySelector(
        '[data-compare-product-data][data-product-handle="' + cssEscapeValue(item.handle) + '"]'
      );
    }
    if (!wrapper) {
      return false;
    }

    function extractField(name) {
      var tpl = wrapper.querySelector('template[data-compare-field="' + name + '"]');
      if (!tpl || !tpl.content) return null;
      var fragment = tpl.content.cloneNode(true);
      /* قالب فارغ فعليًا (بلا عناصر ولا نص غير مسافات) — لا قيمة حقيقية،
         يُعامَل كغياب البيانات (— محايدة) بدل عنصر فارغ بصريًا. */
      var hasElementChild = fragment.childElementCount > 0;
      var hasText = (fragment.textContent || "").trim() !== "";
      if (!hasElementChild && !hasText) return null;
      return fragment;
    }

    var header = findProductHeader(table, item.id);
    if (header) {
      header.innerHTML = "";
      header.removeAttribute("aria-busy");

      var removeButton = document.createElement("button");
      removeButton.type = "button";
      removeButton.className = "button button--ghost compare-table__remove";
      removeButton.setAttribute("data-compare-remove-column", "");
      removeButton.setAttribute("data-product-id", item.id);
      removeButton.setAttribute("aria-label", Naghmah.strings.compareRemove || "");
      removeButton.textContent = Naghmah.strings.compareRemove || "";
      header.appendChild(removeButton);

      var media = extractField("media");
      if (media) {
        var mediaWrap = document.createElement("div");
        mediaWrap.className = "compare-table__media";
        mediaWrap.appendChild(media);
        header.appendChild(mediaWrap);
      }

      var title = extractField("title");
      if (title) {
        var titleWrap = document.createElement("div");
        titleWrap.className = "compare-table__title";
        titleWrap.appendChild(title);
        header.appendChild(titleWrap);
      } else {
        header.appendChild(document.createTextNode("—"));
      }
    }

    ["price", "availability", "vendor", "product_type", "description", "options"].forEach(
      function (fieldName) {
        var row = table.querySelector('tbody tr[data-compare-row="' + fieldName + '"]');
        if (!row) return; /* هذا الصف غير مفعَّل من إعدادات صاحب المتجر */
        var cell = row.querySelector('td[data-product-id="' + cssEscapeValue(item.id) + '"]');
        if (!cell) return;
        cell.innerHTML = "";
        var value = extractField(fieldName);
        if (value) {
          cell.appendChild(value);
        } else {
          cell.textContent = "—";
        }
      }
    );

    return true;
  }

  /* بند: Controller يبقى حيًا طوال دورة حياة الطلب كاملة (fetch +
     res.text() + DOMParser + التطبيق) — تنظيف واحد فقط في المسار النهائي
     الموحَّد. settle() محمية بـonce() ومضمونة الاستدعاء دائمًا عبر
     try/catch حول مسار العرض بأكمله (درس V4 من wishlist.js مُطبَّق منذ
     البداية هنا، لا كتصحيح لاحق). */
  function loadOneColumn(table, run, entry, settle) {
    var item = entry.item;

    if (!isSafeHandle(item.handle) || !isSameOriginProductPath(item.url)) {
      renderColumnUnavailable(table, item);
      settle();
      return;
    }

    var fetchUrl;
    try {
      var url = new URL(item.url, window.location.origin);
      url.searchParams.set("section_id", SECTION_ID);
      fetchUrl = url.pathname + url.search;
    } catch (err) {
      fetchUrl = null;
    }

    if (!fetchUrl) {
      renderColumnUnavailable(table, item);
      settle();
      return;
    }

    var controller = typeof AbortController === "function" ? new AbortController() : null;
    if (controller) run.controllers.add(controller);

    var outcome = null; /* 'unavailable' | 'html' | 'error' | 'abort' */
    var htmlText = null;

    fetch(fetchUrl, {
      headers: { Accept: "text/html" },
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) {
        if (res.status === 404) {
          outcome = "unavailable";
          return null;
        }
        if (!res.ok) {
          throw new Error("compare_http_error_" + res.status);
        }
        return res.text();
      })
      .then(function (text) {
        if (outcome !== "unavailable") {
          htmlText = text;
          outcome = "html";
        }
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") {
          outcome = "abort";
        } else {
          outcome = "error";
        }
      })
      .then(function () {
        if (run.cancelled || !table.isConnected || outcome === "abort") {
          /* بند 4: تنظيف Controller بعد اكتمال المسار حتى في هذه الحالة —
             لا شيء متبقٍ لعرضه، لكن التنظيف يبقى في المسار النهائي
             الموحَّد لا في بداية الدالة. */
          if (controller) run.controllers.delete(controller);
          settle();
          return;
        }

        /* Compare V3: عمود قد يُزال (زر إزالة/عدم توفر) بينما طلب الشبكة
           الخاص به ما زال جاريًا — الجدول (table) يبقى متصلاً بالمستند
           (isConnected صحيحة) رغم أن رأس عمود هذا المنتج بالتحديد حُذف
           فعليًا من thead عبر syncComparePageAfterChangeForRoot. فحص وجود
           رأس العمود حيًا فعليًا هنا (قبل أي renderColumnUnavailable/
           renderColumnNetworkError/applyColumnData/announce) يضمن إهمال
           أي نتيجة متأخرة (Network Error أو 404) بصمت تام لمنتج لم يعد
           موجودًا في المقارنة — لا رسالة خطأ قديمة تظهر لعمود لم يعد له
           وجود، ولا إعلان صوتي مضلِّل بعد compareRemoved. */
        var liveHeader = findProductHeader(table, item.id);
        if (!liveHeader) {
          if (controller) run.controllers.delete(controller);
          settle();
          return;
        }

        /* بند 5: announceText واحد فقط لكل استقرار عمود — يمنع بنيويًا
           أي إعلان مكرر لنفس العمود ضمن نفس الطلب (فرع واحد فقط من هذا
           الشرط يُنفَّذ، وannounce() تُستدعى مرة واحدة في نهاية الدالة). */
        var announceText = null;

        try {
          if (outcome === "unavailable") {
            renderColumnUnavailable(table, item);
            announceText = Naghmah.strings.compareUnavailable || "";
          } else if (outcome === "error") {
            renderColumnNetworkError(table, item);
            announceText = Naghmah.strings.compareLoadError || "";
          } else if (outcome === "html") {
            var applied = applyColumnData(table, item, htmlText);
            if (!applied) {
              renderColumnUnavailable(table, item);
              announceText = Naghmah.strings.compareUnavailable || "";
            }
          }
        } catch (renderErr) {
          /* بند 4: استثناء أثناء applyColumnData أو DOMParser أو أي مرحلة
             Render — لا يُترَك العمود عالقًا بحالة "جارٍ التحميل" أبدًا.
             يُعرَض compareLoadError + Retry + إزالة (renderColumnNetworkError
             تبني الثلاثة معًا)، وتُملأ بقية الخلايا بـ"—" (تُنفَّذ داخل
             renderColumnNetworkError نفسها عبر setColumnFallbackValues)،
             وaria-busy تُزال ضمن نفس الدالة أيضًا. */
          try {
            renderColumnNetworkError(table, item);
          } catch (secondaryErr) {
            /* فشل حتى عرض رسالة الخطأ نفسها — حالة استثنائية نادرة جدًا؛
               لا شيء إضافي ممكن هنا، لكن settle() تبقى مضمونة الاستدعاء
               أدناه بصرف النظر. */
          }
          announceText = Naghmah.strings.compareLoadError || "";
        }

        /* بند 4: حذف Controller من run.controllers بعد اكتمال قراءة
           الاستجابة والتحليل والتطبيق (أو عرض الخطأ) بالكامل — لا في
           بداية الدالة. */
        if (controller) run.controllers.delete(controller);

        if (announceText) {
          announce(announceText);
        }

        settle();
      });
  }

  function scheduleColumnLoad(table, run, entry, onColumnSettled) {
    schedulerEnqueue(run, function (schedulerDone) {
      var settle = once(function () {
        schedulerDone();
        onColumnSettled();
      });
      if (run.cancelled) {
        settle();
        return;
      }
      loadOneColumn(table, run, entry, settle);
    });
  }

  function initComparePageSection(root) {
    root =
      root ||
      document.querySelector('[data-section-type="main-compare"]');
    if (!root) return;

    var app = root.querySelector("[data-compare-app]");
    var tableContainer = root.querySelector("[data-compare-table-container]");
    if (!app || !tableContainer) return;

    var status = root.querySelector("[data-compare-status]");
    var emptyState = root.querySelector("[data-compare-empty-state]");
    var actions = root.querySelector("[data-compare-actions]");

    var state = getPageState(root);
    var run = startNewRun(state); /* تُلغي أي Run سابقة لهذا الجذر فقط */

    var items = readItems();
    updateCountBadges(items.length);

    tableContainer.innerHTML = "";

    if (items.length === 0) {
      tableContainer.setAttribute("hidden", "hidden");
      if (emptyState) emptyState.removeAttribute("hidden");
      if (actions) actions.setAttribute("hidden", "hidden");
      if (status) status.textContent = "";
      return;
    }

    if (emptyState) emptyState.setAttribute("hidden", "hidden");
    if (actions) actions.removeAttribute("hidden");
    tableContainer.removeAttribute("hidden");
    if (status) status.textContent = Naghmah.strings.compareLoading || "";

    var table = buildTable(root, items);
    tableContainer.appendChild(table);

    var entries = items.map(function (item) {
      return { item: item };
    });

    var remaining = entries.length;
    entries.forEach(function (entry) {
      scheduleColumnLoad(table, run, entry, function () {
        remaining--;
        if (remaining === 0 && !run.cancelled) {
          if (status) status.textContent = "";
        }
      });
    });
  }

  /* ======================================================================
     إعادة تهيئة كاملة لكل أقسام main-compare — تُستخدم عند: (أ) إضافة
     محلية من نفس التبويب (منتج جديد يحتاج جلبًا حقيقيًا)، (ب) تغيير قادم
     من تبويب آخر عبر storage event، (ج) مسح الجميع.
     ====================================================================== */
  function reinitAllCompareSections() {
    var items = readItems();
    syncAllToggleButtons(items);
    updateCountBadges(items.length);

    document.querySelectorAll('[data-section-type="main-compare"]').forEach(function (root) {
      initComparePageSection(root);
    });

    try {
      document.dispatchEvent(
        new CustomEvent("naghmah:compare-changed", {
          detail: { count: items.length, items: items }
        })
      );
    } catch (err) {
      /* بيئة قديمة جدًا بلا دعم CustomEvent. */
    }
  }

  /* إزالة تدريجية (زر إزالة عمود/غير متاح) — تُبقي على الأعمدة المحمَّلة
     فعلًا بلا إعادة جلبها، وتُزيل فقط عمود العنصر المحذوف من كل صفوف
     الجدول، مع نقل تركيز مبني على Index (بند 12 من الطلب). */
  /* Compare V2 (بند 2): تعمل الآن على رؤوس الأعمدة الحقيقية (thead th
     [data-compare-product-header]) بدل صف "product" القديم داخل tbody.
     إزالة منتج تعني إزالة رأس عمود (th) واحد من thead، وكل الخلايا (td)
     المطابقة لنفس product-id عبر كل صفوف tbody معًا. */
  function syncComparePageAfterChangeForRoot(root, items) {
    var tableContainer = root.querySelector("[data-compare-table-container]");
    var table = tableContainer ? tableContainer.querySelector("table.compare-table") : null;
    var emptyState = root.querySelector("[data-compare-empty-state]");
    var actions = root.querySelector("[data-compare-actions]");

    if (!table) {
      /* لا جدول مبني بعد (مثال: كانت المقارنة فارغة أصلًا) — لا شيء
         لإزالته هنا؛ initComparePageSection وحدها تبني الجدول من الصفر. */
      return;
    }

    /* Compare V3: Set بدل كائن عادي {} — نفس نمط sanitizeItems أصلاً، لأن
       قيم id قادمة (عبر items من readItems) من localStorage التي يعاملها
       المشروع كبيانات غير موثوقة بالكامل؛ الاعتماد على كائن عادي كخريطة
       بحث يعرّض الكود نظريًا لتأثير مفاتيح خاصة مثل "__proto__"/
       "constructor"/"hasOwnProperty" لو تسللت كقيمة id. */
    var idSet = new Set();
    items.forEach(function (it) {
      idSet.add(it.id);
    });

    var headerRow = table.querySelector("thead tr");
    var originalHeaders = headerRow
      ? Array.prototype.slice.call(
          headerRow.querySelectorAll("th[data-compare-product-header][data-product-id]")
        )
      : [];

    var focusedIndex = -1;
    for (var i = 0; i < originalHeaders.length; i++) {
      if (originalHeaders[i].contains(document.activeElement)) {
        focusedIndex = i;
        break;
      }
    }

    var idsToRemove = [];
    originalHeaders.forEach(function (header) {
      var pid = header.getAttribute("data-product-id");
      if (pid && !idSet.has(pid)) {
        idsToRemove.push(pid);
      }
    });

    var focusedRemoved =
      focusedIndex !== -1 &&
      idsToRemove.indexOf(originalHeaders[focusedIndex].getAttribute("data-product-id")) !== -1;

    idsToRemove.forEach(function (pid) {
      var escapedId = cssEscapeValue(pid);

      var header = table.querySelector(
        'thead th[data-compare-product-header][data-product-id="' + escapedId + '"]'
      );
      if (header && header.parentNode) header.parentNode.removeChild(header);

      var cells = table.querySelectorAll('tbody td[data-product-id="' + escapedId + '"]');
      cells.forEach(function (cell) {
        if (cell.parentNode) cell.parentNode.removeChild(cell);
      });
    });

    if (items.length === 0) {
      if (tableContainer) tableContainer.setAttribute("hidden", "hidden");
      if (emptyState) emptyState.removeAttribute("hidden");
      if (actions) actions.setAttribute("hidden", "hidden");
      if (focusedRemoved) {
        focusElementForA11y(root.querySelector(".compare-page__empty-title"));
      }
      return;
    }

    if (!focusedRemoved) return;

    var remainingHeaderRow = table.querySelector("thead tr");
    var remainingHeaders = remainingHeaderRow
      ? Array.prototype.slice.call(
          remainingHeaderRow.querySelectorAll("th[data-compare-product-header][data-product-id]")
        )
      : [];

    if (remainingHeaders.length === 0) {
      focusElementForA11y(root.querySelector(".compare-page__empty-title"));
      return;
    }

    var targetIndex = focusedIndex < remainingHeaders.length ? focusedIndex : remainingHeaders.length - 1;
    if (targetIndex < 0) targetIndex = 0;
    var targetHeader = remainingHeaders[targetIndex];
    var removeButtonInHeader = targetHeader.querySelector(
      "[data-compare-remove-column], [data-compare-remove-unavailable], [data-compare-retry]"
    );
    if (removeButtonInHeader) {
      removeButtonInHeader.focus();
    } else {
      focusElementForA11y(targetHeader);
    }
  }

  function notifyChange() {
    var items = readItems();
    syncAllToggleButtons(items);
    updateCountBadges(items.length);

    document.querySelectorAll('[data-section-type="main-compare"]').forEach(function (root) {
      syncComparePageAfterChangeForRoot(root, items);
    });

    try {
      document.dispatchEvent(
        new CustomEvent("naghmah:compare-changed", {
          detail: { count: items.length, items: items }
        })
      );
    } catch (err) {
      /* لا شيء يستحق المعالجة. */
    }
  }

  function handleExternalStorageChange() {
    reinitAllCompareSections();
  }

  /* ======================================================================
     تبديل حالة المقارنة من أي زر [data-compare-toggle] في أي قسم.
     ====================================================================== */
  function handleToggleClick(button) {
    var id = button.getAttribute("data-product-id");
    var handle = button.getAttribute("data-product-handle");
    var url = button.getAttribute("data-product-url");
    if (!id) return;

    var wasInCompare = hasItem(id, handle);

    if (wasInCompare) {
      var removed = removeItem(id, handle);
      if (!removed) {
        announce(Naghmah.strings.compareStorageError || "");
        return;
      }
      notifyChange();
      announce(Naghmah.strings.compareRemoved || "");
      return;
    }

    var result = addItem({ id: id, handle: handle, url: url });

    if (!result.ok && result.reason === "limit_reached") {
      /* بند 13: لا تغيير للتخزين، لا تغيير لحالة الزر، لا حذف تلقائي —
         إعلان صريح فقط. */
      announce(Naghmah.strings.compareLimitReached || "");
      return;
    }

    if (!result.ok) {
      announce(Naghmah.strings.compareStorageError || "");
      return;
    }

    reinitAllCompareSections();
    announce(Naghmah.strings.compareAdded || "");
  }

  function retryColumn(button) {
    if (button.disabled) return;
    var root = button.closest('[data-section-type="main-compare"]');
    if (!root) return;

    var table = root.querySelector("table.compare-table");
    if (!table) return;

    var productId = button.getAttribute("data-product-id");
    var header = findProductHeader(table, productId);
    if (!header) return;

    button.disabled = true;

    var item = {
      id: productId,
      handle: button.getAttribute("data-product-handle"),
      url: button.getAttribute("data-product-url")
    };

    header.innerHTML = "";
    header.setAttribute("aria-busy", "true");
    var loadingText = document.createElement("p");
    loadingText.className = "compare-table__loading";
    loadingText.textContent = Naghmah.strings.compareLoading || "";
    header.appendChild(loadingText);

    var state = getPageState(root);
    var run = state.currentRun;
    if (!run || run.cancelled) return;

    scheduleColumnLoad(table, run, { item: item }, function () {});
  }

  function removeUnavailableColumn(button) {
    var id = button.getAttribute("data-product-id");
    var removed = removeItem(id);
    if (!removed) {
      announce(Naghmah.strings.compareStorageError || "");
      return;
    }
    notifyChange();
    announce(Naghmah.strings.compareRemoved || "");
  }

  function removeColumn(button) {
    var id = button.getAttribute("data-product-id");
    var removed = removeItem(id);
    if (!removed) {
      announce(Naghmah.strings.compareStorageError || "");
      return;
    }
    notifyChange();
    announce(Naghmah.strings.compareRemoved || "");
  }

  function bindDelegatedListeners() {
    if (delegatedListenersBound) return;
    delegatedListenersBound = true;

    document.addEventListener("click", function (evt) {
      var toggleButton = evt.target.closest("[data-compare-toggle]");
      if (toggleButton) {
        evt.preventDefault();
        handleToggleClick(toggleButton);
        return;
      }

      var clearButton = evt.target.closest("[data-compare-clear-all]");
      if (clearButton) {
        evt.preventDefault();
        var confirmMessage = Naghmah.strings.compareClearConfirm || "";
        if (confirmMessage && !window.confirm(confirmMessage)) return;

        var cleared = clearAllItems();
        if (!cleared) {
          announce(Naghmah.strings.compareStorageError || "");
          return;
        }

        var originRoot = clearButton.closest('[data-section-type="main-compare"]');
        reinitAllCompareSections();
        announce(Naghmah.strings.compareRemoved || "");
        if (originRoot) {
          focusElementForA11y(originRoot.querySelector(".compare-page__empty-title"));
        }
        return;
      }

      var retryButton = evt.target.closest("[data-compare-retry]");
      if (retryButton) {
        evt.preventDefault();
        retryColumn(retryButton);
        return;
      }

      var removeUnavailableButton = evt.target.closest("[data-compare-remove-unavailable]");
      if (removeUnavailableButton) {
        evt.preventDefault();
        removeUnavailableColumn(removeUnavailableButton);
        return;
      }

      var removeColumnButton = evt.target.closest("[data-compare-remove-column]");
      if (removeColumnButton) {
        evt.preventDefault();
        removeColumn(removeColumnButton);
        return;
      }
    });

    window.addEventListener("storage", function (evt) {
      if (evt.key !== STORAGE_KEY) return;
      handleExternalStorageChange();
    });

    /* Compare V2 (بند 1): naghmah:product-changed تُطلَق فعليًا من
       assets/product.js بعد كل استبدال Combined Listing ناجح (لا تعديل
       على product.js هنا إطلاقًا — الحدث موجود ومُطلَق مسبقًا بهذا الاسم
       بالضبط، مع event.detail.pageRoot = الجذر الجديد المُستورَد). مزامنة
       فورية لأزرار المقارنة داخل هذا الجذر تحديدًا، دون انتظار الدورة
       التالية للـMutationObserver العالمية. */
    document.addEventListener("naghmah:product-changed", function (evt) {
      if (!evt || !evt.detail || !evt.detail.pageRoot) return;
      syncToggleButtonsWithin(evt.detail.pageRoot, readItems());
    });
  }

  if (Naghmah.registerSection) {
    Naghmah.registerSection("main-compare", initComparePageSection);
  }

  document.addEventListener("shopify:section:load", function (evt) {
    var wrapper = evt.target;
    if (!wrapper || !wrapper.querySelector) return;
    syncAllToggleButtons();
    updateCountBadges(readItems().length);
  });

  /* يدعم كون wrapper نفسه هو قسم Compare (matches) أو يحويه (querySelector)
     — نفس درس V3 من wishlist.js. إلغاء Run الخاصة بهذا الجذر فقط، بلا أي
     تأثير على أي قسم main-compare آخر معروض بالتوازي. */
  document.addEventListener("shopify:section:unload", function (evt) {
    var wrapper = evt.target;
    if (!wrapper || !wrapper.querySelector) return;
    var root =
      wrapper.matches && wrapper.matches('[data-section-type="main-compare"]')
        ? wrapper
        : wrapper.querySelector('[data-section-type="main-compare"]');
    if (!root) return;

    var state = comparePageStates.get(root);
    if (state && state.currentRun) {
      cancelRun(state.currentRun);
    }
    comparePageStates.delete(root);
  });

  Naghmah.onReady(function () {
    bindDelegatedListeners();
    initCompareMutationObserver();
    syncAllToggleButtons();
    updateCountBadges(readItems().length);
    document
      .querySelectorAll('[data-section-type="main-compare"]')
      .forEach(function (root) {
        initComparePageSection(root);
      });
  });
})();
